import { Controller } from '@hotwired/stimulus';

// Shows or hides the password in the input target, with the button labels as values
export default class extends Controller {
    static targets = ['input', 'button', 'showIcon', 'hideIcon'];
    static values = { showLabel: String, hideLabel: String };

    toggle() {
        const isVisible = 'password' === this.inputTarget.type;

        this.inputTarget.type = isVisible ? 'text' : 'password';
        this.buttonTarget.setAttribute('aria-pressed', String(isVisible));
        this.buttonTarget.setAttribute('aria-label', isVisible ? this.hideLabelValue : this.showLabelValue);
        this.showIconTarget.classList.toggle('hidden', isVisible);
        this.hideIconTarget.classList.toggle('hidden', !isVisible);
    }
}
